import { SSRProvider } from '@react-aria/ssr';
import { ReactElement, ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';

import GlobalStyle from '../GlobalStyle';
import { CalmTheme, D2CTheme, PortalTheme } from '../ThemeProvider';

const DesignSystemProvider = ({
	theme,
	children,
}: {
	theme: typeof CalmTheme | typeof PortalTheme | typeof D2CTheme;
	children?: ReactNode;
}): ReactElement => {
	return (
		<SSRProvider>
			<GlobalStyle />
			<ThemeProvider theme={theme}>{children}</ThemeProvider>
		</SSRProvider>
	);
};

export default DesignSystemProvider;
